module.exports = __webpack_public_path__ + "img/Logo_Teman_Bus.21e6777e.png";